import NumberComponent from './Number';

export default NumberComponent;
